declare const AreaCalc: any; // Controls/Customer/ViewProductV4-AreaCalc.min.js

// Product view Calculator
AreaCalc.init({
    mainContSelector: 'section.js-product-view',
    customFieldsSelector: 'div.js-custom-fields',
    squareFromPackagesCalculator: {
        quantityInputSelector: 'input.js-quantity',
        quantityHideSelfNotParent: false,
        priceSelector: 'span.js-sellprice-formatted',
        appendUnitTextToMainPrice: false,
        insertCalcBeforeContainer: 'div.js-product-view-price-calc-container'
    }
});